import type { FreeViewLimit } from '../type/free-view-limit.type';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter, type Event } from '@patsnap/tahiti-core/common/event';

export const FreeViewLimitService = Symbol('FreeViewLimitService');

export interface FreeViewLimitService {
    onStateChange: Event<FreeViewLimit>;
    state: FreeViewLimit;
    updateState(isOverFreeViewLimit: boolean, limitMessage?: string): void;
}

@injectable()
export class FreeViewLimitServiceImpl implements FreeViewLimitService {
    private _onStateChangeEmitter = new Emitter<FreeViewLimit>();
    readonly onStateChange = this._onStateChangeEmitter.event;

    // 免费权限一周20篇专利
    private _state: FreeViewLimit = {
        isOverFreeViewLimit: false,
        limitMessage: '',
    };

    public get state() {
        return { ...this._state };
    }

    public updateState(isOverFreeViewLimit: boolean, limitMessage?: string) {
        this._state.isOverFreeViewLimit = isOverFreeViewLimit;
        this._state.limitMessage = limitMessage || '';
        this._onStateChangeEmitter.fire(this.state);
    }
}
